/**
 * Normalizes a string by converting to uppercase and trimming whitespace
 * @param str - String to normalize
 * @returns Normalized string or empty string if input is null/undefined
 */
export function normalizeString(str: string | null | undefined): string {
    return str?.toUpperCase().trim() ?? '';
}

